import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutRmSpCities extends Layout {
    sourceRmSpcities: DataSource;
    tableRmspCities: Table;
}
